import { JsonLdResource } from "../base";

export class ResourceCollection<T extends JsonLdResource> {
  constructor(
    private pItems: T[] = [],
    private pCurrentPage = 1,
    private pTotalPages = 1,
    private pTotalItems = 0,
    private pItemsPerPage = 30,
    private pView = '',
  ) {}

  get items(): T[] {
    return this.pItems;
  }

  get currentPage(): number {
    return this.pCurrentPage;
  }

  get totalPages(): number {
    return this.pTotalPages;
  }

  get totalItems(): number {
    return this.pTotalItems;
  }

  get itemsPerPage(): number {
    return this.pItemsPerPage;
  }

  get view(): string {
    return this.pView;
  }
}
